import { render, staticRenderFns } from "./InvoicesBuilder.vue?vue&type=template&id=da075f02"
import script from "./InvoicesBuilder.vue?vue&type=script&lang=js"
export * from "./InvoicesBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports